import { styled, Box } from '@mui/material';
import { SymbolIcon } from '../icons';
import LoadingIndicator from '../LoadingIndicator';
import theme from '../../theme';

export type ScoreProps = {
    size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
    score?: number | null;
    loading?: boolean;
    color?: string;
};

const ScoreRoot = styled('span', {
    shouldForwardProp: (propName) => propName !== 'size',
})<{ size: ScoreProps['size'] }>(({ size }) => ({
    fontFamily: 'bariolthin',
    display: 'inline-flex',
    textAlign: 'center',
    lineHeight: 1,
    whiteSpace: 'nowrap',
    '& .BinoScore_loadingIndicator': {
        height: '100%',
    },
    ...(size === 'xsmall' && {
        float: `left`,
        position: `relative`,
        // marginTop: -7,
        fontSize: 18,
        width: 40,
        //border: `1px solid #000000`,
        '& > .BinoScore_symbol': {
            width: 10,
            height: 10,
        },
    }),
    ...(size === 'small' && {
        fontSize: 48,
        margin: 24,
        '& > .BinoScore_symbol': {
            width: 20,
            height: 20,
        },
    }),
    ...(size === 'medium' && {
        fontSize: 48,
        margin: 24,
        '& > .BinoScore_symbol': {
            width: 20,
            height: 20,
        },
    }),
    ...(size === 'large' && {
        fontSize: 66,
        // marginTop: -20,
        '& > .BinoScore_symbol': {
            width: 32,
            height: 32,
        },
    }),
    ...(size === 'xlarge' && {
        fontSize: 110,
        // marginTop: -120,
        '& > .BinoScore_symbol': {
            width: 32,
            height: 32,
        },
    }),
}));

function Score(props: ScoreProps) {
    const {
        size = 'large',
        score,
        loading = false,
        color = theme.primaryColor,
    } = props;
    const symbolStyle = {
        color: color,
        display: score ? '' : 'none',
    };

    return (
        <ScoreRoot size={size}>
            <div>{score ? score : '?'}</div>
            <Box
                fontSize={0}
                alignSelf="flex-start"
                className="BinoScore_symbol"
            >
                {(score || loading) && size !== 'xsmall' ? (
                    loading ? (
                        <LoadingIndicator
                            delay={0}
                            size={'100%'}
                            className="BinoScore_loadingIndicator"
                        />
                    ) : (
                        <SymbolIcon size={'100%'} sx={{ color }} />
                    )
                ) : (
                    <SymbolIcon size={5} style={symbolStyle} />
                )}
            </Box>
        </ScoreRoot>
    );
}

export default Score;
